import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import Button from '../../../../Button';
import Loader from '../../../../common/Loader';

import { INSURANCE_FLOW_TYPE } from '../../../../../constants/insurance-flow-type';

import { selectInsuranceToDoTaskCompleting } from '../../../../../redux/manage-insurances/selectors/common';

import styles from './index.styl';

const FormButtons = ({ flowType, cancel = () => {}, disableSubmitButton }) => {
  const { formatMessage } = useIntl();

  const isInsuranceToDoTaskCompleting = useSelector(
    selectInsuranceToDoTaskCompleting,
  );

  switch (flowType) {
    case INSURANCE_FLOW_TYPE.PROFILE: {
      return (
        <div className={styles.profileFlowButtonWrapper}>
          <Button
            raised
            color="primary"
            className={styles.profileFlowButton}
            disabled={disableSubmitButton}
            type="submit"
          >
            {formatMessage({ id: 'common.save' })}
          </Button>
          <Button
            raised
            color="accent"
            onClick={cancel}
            className={styles.profileFlowButton}
          >
            {formatMessage({ id: 'common.cancel' })}
          </Button>
        </div>
      );
    }

    case INSURANCE_FLOW_TYPE.PAPERWORK:
    case INSURANCE_FLOW_TYPE.GET_CARE_FLOW: {
      return (
        <div className={styles.paperworkFlowButtonWrapper}>
          <Button
            className={styles.paperworkFlowButton}
            raised
            color="primary"
            type="submit"
            disabled={disableSubmitButton}
          >
            {formatMessage({ id: 'common.next' })}
          </Button>
        </div>
      );
    }

    case INSURANCE_FLOW_TYPE.TO_DO: {
      return (
        <div className={styles.toDoFlowButtonsWrapper}>
          <Button
            color="accent"
            className={styles.toDoFlowButton}
            onClick={cancel}
          >
            {formatMessage({
              id: 'common.cancel',
            })}
          </Button>

          <Button
            color="primary"
            type="submit"
            className={styles.toDoFlowButton}
            disabled={disableSubmitButton}
          >
            {isInsuranceToDoTaskCompleting ? (
              <Loader className={styles.toDoFlowLoader} />
            ) : (
              formatMessage({ id: 'common.complete' })
            )}
          </Button>
        </div>
      );
    }

    default:
      return null;
  }
};

FormButtons.propTypes = {
  cancel: PropTypes.func,
  disableSubmitButton: PropTypes.bool,
  flowType: PropTypes.oneOf(Object.keys(INSURANCE_FLOW_TYPE)),
};

export default FormButtons;



// WEBPACK FOOTER //
// ./src/components/forms/InsuranceForm/components/FormButtons/index.jsx